import React, {Fragment, useState} from "react"
import HoverButton from "../../buttons/HoverButton";

export default function AvatarSelector(props) {

    const [selected, setSelected] = useState(props.value);

    let icons = [];

    for (let y = 1; y <= 6; y++) {
        for (let x = 1; x <= 8; x++) {
            const icon = `avatar_${x}_${y}`;
            icons.push(<div className={`testimonials__pic${icon === selected ? ' is-selected' : ''}`} key={icon} onClick={() => setSelected(icon) }>
                <div className={`avatar-icon ${icon}`} />
            </div> )
        }
    }

    return <Fragment>
        <h3 className="feedback__msg feedback__msg--with-no-space">Select Avatar</h3>
        <div className="feedback__avatar-selector-container">
            {icons}
        </div>

        <HoverButton onClick={() => props.onSelect(selected)} className={'button--green'}>Confirm selection</HoverButton>
    </Fragment>

}